export const APP_CONSTRAINTS = {
  SET_APP_DIMENSIONS: "SET_APP_DIMENSIONS",
};
